export default {"src":"/_next/static/media/mim.af724075.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};